var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "vscroll",
    class: _vm.$style.vscroll
  }, [_c('div', {
    ref: "topBlock",
    class: _vm.$style.block,
    style: {
      height: "".concat(this.topHeight, "px")
    }
  }), _vm._l(_vm.batch, function (option, index) {
    return [_vm._t("default", null, {
      "option": option,
      "index": index + _vm.startIndex
    })];
  }), _c('div', {
    ref: "botBlock",
    class: _vm.$style.block,
    style: {
      height: "".concat(this.botHeight, "px")
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }